import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockingProgressComponent } from './blocking-progress.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BlockingProgressService } from '@app/core/modules/blocking-progress/blocking-progress.service';
import { SpinnerModule } from '@app/core/components/spinner/spinner.module';

@NgModule({
  declarations: [BlockingProgressComponent],
  imports: [CommonModule, MatProgressSpinnerModule, SpinnerModule],
  providers: [],
  exports: [BlockingProgressComponent]
})
export class BlockingProgressModule {
  static forRoot(): ModuleWithProviders<BlockingProgressModule> {
    return {
      ngModule: BlockingProgressModule,
      providers: [BlockingProgressService]
    };
  }
}
